import * as React from "react"
import ContactForm from "@components/ContactForm"
import ApplyForm from "@components/ApplyForm"

const StrapiForm = ({
    formType,
    content
}: GatsbyTypes.FormFragment) => {
    if (formType === "contact_formulier") {
        return <ContactForm content={content} />
    }
    if (formType === "aanmeld_formulier") {
        return <ApplyForm content={content} />
    }
    return <ContactForm />
}

export default StrapiForm
